import Vue from "vue";
import Vuex from "vuex";
import rootModule from "./modules/root";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    root: rootModule,
  },
});

export default store;
